export class VideoVid {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get video() {
        return this.parent;
    }
}
